<template>
    <div>
        <div ref="map-root" class="rounded overflow-hidden" style="width: 100%; height: 100%"></div>
        <div id="map-popup" title="myproject" class="ol-popup">
            <a href="#" id="popup-closer" class="ol-popup-closer"></a>
            <div id="popup-content"></div>
        </div>
    </div>


</template>

<script>

import View from 'ol/View'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import OSM from 'ol/source/OSM'
import {fromLonLat} from 'ol/proj'
import {Feature} from "ol";
import {Style} from "ol/style";
import {Point} from "ol/geom";
import { Icon } from "ol/style"
import {Vector as VectorLayer} from "ol/layer";
import {Vector as VectorSource} from "ol/source";
import {Overlay} from "ol";
import {transform} from "ol/proj";

import locationPin from '../../assets/img/location_pin.png';

export default {
    name: "MapBox",
    props: {
        coordinates: { type: Object, default: () => { return {} } },
        centerLon: { type: Number, default: 33.0955 },
        centerLat: { type: Number, default: 68.9614 },
    },
    data() {
        return {
            map: null,
            view: null,
            markerSource: null,
            locationPin
        }
    },
    computed: {
        mapUrl() { return process.env.VUE_APP_MAP_HOST + '/map/{z}/{x}/{y}.png' }
    },
    methods: {
        showAddress() {
            const vm = this;

            vm.markerSource.getFeatures().forEach(function (item) {
                vm.markerSource.removeFeature(item);
            })

            if (vm.coordinates["lat"] && vm.coordinates["lon"]) {
                const point = new Point(transform([vm.coordinates.lon, vm.coordinates.lat], 'EPSG:4326', 'EPSG:3857'));

                let iconFeature = new Feature({
                    geometry: point,
                    type: 'Point',
                });
                let iconStyle = new Style({
                    image: new Icon({
                        src: vm.locationPin,
                        width: 48,
                        height: 48,
                        anchor: [0.5, 1]
                    })
                })
                iconFeature.setStyle(iconStyle);
                vm.markerSource.addFeature(iconFeature);

                setTimeout(() => {
                    vm.centerMap()
                }, 200)
            }

        },

        centerMap(lat = null, lon = null) {
            const vm = this;
            let centerLat = lat ? lat : vm.coordinates.lat;
            let centerLon = lon ? lon : vm.coordinates.lon;
            const point = new Point(transform([centerLon, centerLat], 'EPSG:4326', 'EPSG:3857'));

            vm.view.animate({
                center: point.getCoordinates(),
                zoom: vm.view.getZoom() >= 15 ? vm.view.getZoom() : 15,
                duration: 200,
            })
        }
    },
    mounted() {
        let zoom = 11;

        this.view = new View({
          zoom: 11,
          center: fromLonLat([this.centerLon, this.centerLat]),
          constrainResolution: true
        });
        this.markerSource = new VectorSource();
        this.map = new Map({
            target: this.$refs['map-root'],
            layers: [
                new TileLayer({
                    source: new OSM({
                        url: this.mapUrl,
                        crossOrigin: null
                    }),
                }),
                new VectorLayer({ source: this.markerSource })
            ],
            view: this.view
        })

        if (this.coordinates["lat"] && this.coordinates["lon"]) {
            this.showAddress();
        }

        const vm = this;
        this.map.on('click', function (e) {
            const point = new Point(transform([e.coordinate[0], e.coordinate[1]], 'EPSG:3857', 'EPSG:4326'));
            vm.$emit('map-clicked', point.getCoordinates())
        })

    },
    watch: {
        'coordinates': {
            handler: function(newValue, oldValue) {
                if (newValue && Object.keys(newValue).length === 0) {
                    this.showAddress();
                }
            },
         },
    }
}
</script>

<style>
@import "../../assets/ol.css";
</style>